export function insertRouteAfter(routes, insertAfter, toInsert) {
  const out = routes.reduce(
    (acc, route) => [...acc, route, ...(route.i18n_value === insertAfter ? [toInsert] : [])],
    [],
  );

  return out;
}
